import React from 'react';
import styles from './RegistrationForm.scss';
import { deployEnvironment } from '../../config.js';
export const EnvironmentField = () => {
    if (deployEnvironment !== 'PROD') {
        return (React.createElement("input", { className: styles.hidden, type: "text", name: "environment", value: deployEnvironment, readOnly: true, "aria-hidden": true }));
    }
    return React.createElement(React.Fragment, null);
};
